import React, { FC } from 'react';

import { GridColumnCheckboxProps, GridColumnProps, GridColumnSwitchProps } from './types';

export const GridColumn: FC<GridColumnProps> = ({ children }) => {
  return <React.Fragment>{children}</React.Fragment>;
};

GridColumn.displayName = 'Column';

export const GridColumnCheckbox: FC<GridColumnCheckboxProps> = ({ children }) => {
  return <React.Fragment>{children}</React.Fragment>;
};

GridColumnCheckbox.displayName = 'ColumnCheckbox';

export const GridColumnSwitch: FC<GridColumnSwitchProps> = ({ children }) => {
  return <React.Fragment>{children}</React.Fragment>;
};

GridColumnCheckbox.displayName = 'ColumnSwitch';
